<template>
  <modal class="likes" :name="`visit-modal${personId}`" height="auto">
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>

    <Button
      class="close"
      @click.native="$modal.hide(`visit-modal${personId}`)"
      margin="10px"
      color="#31b9be"
      bgcolor="transparent"
      width="30px"
      padding="0"
      icon="close-blue"
    ></Button>
    <h3>{{ $t("dash.visit.title") }} {{ personName }}</h3>

    <h3 class="blue">{{ visit.datetime | moment("DD MMM [om] HH:mm") }}</h3>

    <div id="request-success">
      <div class="success-checkmark">
        <div id="check-icon">
          <span class="icon-line line-tip"></span>
          <span class="icon-line line-long"></span>
          <div class="icon-circle"></div>
          <div class="icon-fix"></div>
        </div>
      </div>
      <div>
        <p>{{ $t("dash.visit.message-success") }}</p>
      </div>
    </div>
    <div>
      <h4 class="pink--text">{{ $t("dash.visit.message") }}</h4>
      <TextAreaField
        rows="3"
        v-model="message"
        :width="100"
        labelTitle
        :placeholder="$t('dash.visit.form-message')"
      ></TextAreaField>
      <Button
        :title="$t('dash.visit.action-send')"
        shadow="true"
        @click.native="confirmVisit"
        margin="1rem 0"
      ></Button>
    </div>
<!--    <div v-else>
      <h4 class="pink&#45;&#45;text">{{ $t("dash.visit.message-sent") }}</h4>
      <p class="message">
        "{{ visit.message }}"
        <span class="read-confirmation">
          ({{
            visit.messageRead
              ? $t("dash.visit.read")
              : $t("dash.visit.not-read")
          }})
        </span>
      </p>
    </div>-->
  </modal>
</template>

<script>
import {neoparentVisits} from "@/api";

export default {
  name: "VisitModal",
  props: {
    personName: { required: true },
    personId: { required: true },
    visit: { required: true }
  },
  data() {
    return {
      message: null,
      error: null
    };
  },
  methods: {
    async confirmVisit() {
      try {
        let data = {
          nurseId: this.$store.getters.nurse.id
        };

        if (this.message) {
          // Save message to database
          data.message = this.message;
        }

        await neoparentVisits.confirmVisit(this.visit.id, data)
          .then(() => {
            this.showSuccesAnimation();
            this.visit.message = this.message;
            this.$emit("confirmed", {
              message: this.message
            });
            this.$forceUpdate();
          })
          .catch(e => {
            this.consoleLog(e);
            this.error = this.$t("error.general.connection");
          });

        /*await axios
          .post(
            `${this.$backendRoot}/patients/${
              this.$session.get("patient").id
            }/visit/${this.visit.id}/confirm`,
            data
          )
          .then(res => {
            this.showSuccesAnimation();
            this.visit.message = this.message;
            this.$emit("confirmed", {
              nurseId: this.$session.get("user").id,
              message: this.message
            });
            this.$forceUpdate();
          })
          .catch(e => {
            this.consoleLog(e);
            this.error = this.$t("error.general.connection");
          });*/
      } catch (e) {
        this.consoleLog(e);
        this.error = this.$t("error.general.connection");
      }
    },
    showSuccesAnimation() {
      document.getElementById("request-success").style.display = "flex";
      setTimeout(() => {
        document.getElementById("request-success").style.display = "none";
        this.$modal.hide(`visit-modal${this.personId}`);
      }, 5000);
    }
  }
};
</script>

<style scoped lang="scss">
h4 {
  margin-bottom: 0;
}
p {
  margin-top: 0;

  &.message {
    width: 100%;
    height: 100%;
    margin: 8px 0;
  }

  .read-confirmation {
    font-style: italic;
  }
}

#request-success {
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
</style>
